export default function Contact() {
  return (
    <section id="contact" className="py-10 bg-white">
      <div className="container mx-auto px-4">

        {/* 🔹 Google Map */}
        <div className="mb-8">
          <iframe
            title="Google Map"
            src="https://www.google.com/maps?q=SSP+NextGen+E-Bikes,+Plot+No.+7,+Ramalayam+Road,+Bagh+Ameer,+Sumitra+Nagar+Colony,+Kukatpally,+Hyderabad,+Telangana+500072&output=embed"
            width="100%"
            height="300"
            className="rounded-xl shadow-lg border border-green-100"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>

        {/* 🔹 Title */}
        <h3 className="text-2xl font-bold mb-8 text-green-700 text-center">
          Contact Us
        </h3>

        {/* 🔹 GRID – SAME HEIGHT + SIDE MARGIN */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-stretch mx-4 md:mx-10">

          {/* LEFT COLUMN */}
          <div className="space-y-4 w-full h-full flex flex-col">

            {/* ADDRESS */}
            <div className="flex items-start p-4 rounded-lg shadow-md border border-gray-200 flex-1">
              <div className="mr-3 bg-green-600 p-2 rounded-full">
                <span className="text-white text-lg">📍</span>
              </div>
              <div>
                <h4 className="text-lg font-semibold">Our Head Office</h4>
                <p className="mt-1 text-gray-700 text-sm leading-relaxed">
                  Plot No. 7, Ramalayam Road, Bagh Ameer,
                  Sumitra Nagar Colony, Kukatpally,
                  Hyderabad – 500072
                </p>
              </div>
            </div>

            {/* PHONE */}
            <div className="flex items-start p-4 rounded-lg shadow-md border border-gray-200 flex-1">
              <div className="mr-3 bg-green-600 p-2 rounded-full">
                <span className="text-white text-lg">📞</span>
              </div>
              <div>
                <h4 className="text-lg font-semibold">Call for Help</h4>
                <p className="mt-1 text-gray-700 text-sm">
                  <a href="tel:6309066338" className="text-green-700 underline">
                    6309066338
                  </a>
                </p>
              </div>
            </div>

            {/* EMAIL */}
            <div className="flex items-start p-4 rounded-lg shadow-md border border-gray-200 flex-1">
              <div className="mr-3 bg-green-600 p-2 rounded-full">
                <span className="text-white text-lg">📧</span>
              </div>
              <div>
                <h4 className="text-lg font-semibold">Email</h4>
                <p className="mt-1 text-gray-700 text-sm">
                  <a
                    href="mailto:sspnextgen@gmail.com"
                    className="text-green-700 underline"
                  >
                    sspnextgen@gmail.com
                  </a>
                </p>
              </div>
            </div>

          </div>

          {/* RIGHT COLUMN — FORM */}
          <div className="p-4 rounded-lg shadow-md border border-gray-200 w-full h-full flex flex-col">

            <input
              type="text"
              placeholder="Your Name"
              className="w-full border mb-4 px-3 py-2 rounded-md text-sm"
            />

            <input
              type="email"
              placeholder="Your Email"
              className="w-full border mb-4 px-3 py-2 rounded-md text-sm"
            />

            <select className="w-full border mb-4 px-3 py-2 rounded-md text-sm">
              <option>Select Service</option>
              <option>General Inquiry</option>
              <option>Product Details</option>
              <option>Support Request</option>
            </select>

            <textarea
              placeholder="Message"
              className="w-full border px-3 py-2 rounded-md h-28 resize-none text-sm"
            ></textarea>

            <button className="w-full mt-4 bg-green-700 text-white py-2 rounded-md hover:bg-green-800 transition text-sm">
              Send Message
            </button>

          </div>

          {/* SOCIAL ICONS */}
          <div className="flex justify-center space-x-6 mt-6 mb-10 md:col-span-2">
            <a href="https://www.instagram.com/ssp_nextgen_ebikes/" target="_blank">
              <img
                src="https://img.icons8.com/color/48/instagram-new--v1.png"
                className="h-8 w-8 hover:scale-110 transition"
                alt="Instagram"
              />
            </a>

            <a href="https://www.facebook.com/profile.php?id=61579405079274" target="_blank">
              <img
                src="https://img.icons8.com/color/48/facebook-new.png"
                className="h-8 w-8 hover:scale-110 transition"
                alt="Facebook"
              />
            </a>

            <a href="https://wa.me/916309066338?text=Hello!%20I%20want%20to%20know%20more." target="_blank">
              <img
                src="https://img.icons8.com/color/48/whatsapp.png"
                className="h-8 w-8 hover:scale-110 transition"
                alt="WhatsApp"
              />
            </a>
          </div>

        </div>
      </div>
    </section>
  );
}
